import { isWithinInterval, isAfter, parseISO } from 'date-fns';
import type { Performance } from '../types';

export const getCurrentAndNextPerformances = (
  performances: Performance[],
  currentTime: Date
) => {
  // Group by stage
  const byStage: Record<string, { current?: Performance; next?: Performance }> = {};

  // First, find current performances
  performances.forEach(perf => {
    const start = parseISO(perf.start_time);
    const end = parseISO(perf.end_time);
    const stage = perf.stage || 'Unknown';

    if (!byStage[stage]) byStage[stage] = {};

    if (isWithinInterval(currentTime, { start, end })) {
      byStage[stage].current = perf;
    } else if (isAfter(start, currentTime)) {
      // Potentially the next one.
      // We want the *earliest* next one.
      const currentNext = byStage[stage].next;
      if (!currentNext || isAfter(parseISO(currentNext.start_time), start)) {
        byStage[stage].next = perf;
      }
    }
  });

  return Object.entries(byStage).map(([stage, data]) => ({
    stage,
    current: data.current,
    next: data.next
  }));
};
